import { createSlice } from '@reduxjs/toolkit';

import { deleteReviewById } from './actions';

type DeleteReviewState = {
  isDeleting: boolean;
  deleteError: null | { message: string; code: number };
  deletedId: string | null;
};

const initialState: DeleteReviewState = {
  isDeleting: false,
  deleteError: null,
  deletedId: null,
};

const deleteReviewSlice = createSlice({
  name: 'deleteReview',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteReviewById.pending, (state) => {
        state.isDeleting = true;
        state.deleteError = null;
      })
      .addCase(deleteReviewById.fulfilled, (state, action) => {
        state.isDeleting = false;
        state.deletedId = action.payload;
      })
      .addCase(deleteReviewById.rejected, (state, action) => {
        state.isDeleting = false;
        state.deleteError = action.payload as any;
      });
  },
});

export const deleteReviewReducer = deleteReviewSlice.reducer;
